import { useEffect, useState } from "react";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import Select from "react-select";
import axiosInstance from "../../../axiosInterceptor";
import { pageSchema } from "../../../Validation/Validation";
import { customStyles } from "../../../utils/constant";

const actionOptions = [
  { value: "Add", label: "Add" },
  { value: "Update", label: "Update" },
  { value: "Delete", label: "Delete" },
  { value: "View", label: "View" },
  { value: "Status", label: "Status" },
];

const AddPage = ({ editData, fetchPaginationData, setEditData }) => {
  const editingId = editData?._id;
  const [loading, setLoading] = useState(false);

  const {
    errors,
    values,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    resetForm,
  } = useFormik({
    initialValues: {
      page: "",
      action: [],
    },
    validationSchema: pageSchema,
    enableReinitialize: false,
    onSubmit: async (values) => {
      setLoading(true);

      try {
        const payload = {
          pageName: values.page,
          action: values.action.map((item) => item.value),
        };

        const response = editingId
          ? await axiosInstance.put(`/page/updatePage/${editingId}`, payload)
          : await axiosInstance.post("/page/createPage", payload);

        if (response.status === 200) {
          toast.success(response.data.message);

          resetForm();
          setEditData(null);
          fetchPaginationData && fetchPaginationData();
        }
      } catch (err) {
        toast.error(err?.response?.data?.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    },
  });

  useEffect(() => {
    if (editingId && editData) {
      setFieldValue("page", editData.pageName || "");

      setFieldValue(
        "action",
        editData.action?.map((item) => ({
          value: item,
          label: item,
        })) || []
      );
    } else {
      resetForm();
    }
  }, [editingId, editData, setFieldValue, resetForm]);

  return (
    <div className="row grid-margin stretch-card">
      <div className="col-md-12">
        <div className="card">
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="row g-3">
                {/* Page */}
                <div className="col-lg-6 col-md-12">
                  <label className="col-form-label">Page</label>

                  <input
                    type="text"
                    name="page"
                    className="form-control form-control-sm border border-dark"
                    placeholder="Enter Page Name"
                    value={values.page}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />

                  {touched.page && errors.page && (
                    <div className="text-danger mt-2">{errors.page}</div>
                  )}
                </div>

                {/* Action */}
                <div className="col-lg-6 col-md-12">
                  <label className="col-form-label">Action</label>

                  <Select
                    isMulti
                    name="action"
                    options={actionOptions}
                    value={values.action}
                    onChange={(selected) =>
                      setFieldValue("action", selected || [])
                    }
                    onBlur={() => setFieldValue("action", values.action)}
                    placeholder="Select Actions"
                    styles={customStyles}
                  />

                  {touched.action && errors.action && (
                    <div className="text-danger mt-2">{errors.action}</div>
                  )}
                </div>

                {/* Buttons */}
                <div
                  className="col-12 mt-4 d-flex justify-content-center"
                  style={{ gap: "15px" }}
                >
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                  >
                    {loading
                      ? "Loading..."
                      : editingId
                      ? "Update"
                      : "Add"}
                  </button>

                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={() => {
                      resetForm();
                      setEditData(null);
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddPage;